export enum PurchaseType {
  PURCHASE = 'purchase',
  SUBSCRIPTION = 'subscription',
  GIFTING = 'gifting'
}
